import { CookiePreferencesPortal } from "@design-system/portals/CookiePreferencesPortal";
import { AboutUsVideoPortal } from "@modules/home/portals/AboutUsVideoPortal";

const portals: any[] = [
  AboutUsVideoPortal,
  CookiePreferencesPortal,
  // GeneralAssemblyAnnouncementPortal,
];

export function PortalsWrapper() {
  return portals.map((Portal, index) =>
    Portal !== null ? <Portal key={index} /> : null,
  );
}
